import { render } from "./AiSideBar.vue?vue&type=template&id=76d38516&scoped=true"
import script from "./AiSideBar.vue?vue&type=script&lang=js"
export * from "./AiSideBar.vue?vue&type=script&lang=js"

import "./AiSideBar.vue?vue&type=style&index=0&id=76d38516&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d38516"]])

export default __exports__